module.exports = __webpack_public_path__ + "static/media/04.4e9b612c.png";